<button class="btn btn-link" (click)="go()">이슈트래커페이지 바로가기</button>

<table class="table table-sm table-bordered text-center">
    <caption>
        스태프분들은 <a href="https://github.io" target="_blank">Github</a>에 가입후 아이디를 알려주세요.
        개발자가 권한을 부여해야만 다음 게시판에 열람 및 작성이 가능합니다.
    </caption>
    <thead class="thead-light">
        <tr>
            <th>
                항목
            </th>
            <th>
                게시판
            </th>
            <th>
                권한
            </th>
        </tr>
    </thead>

    <tbody>
        <tr>
            <td>
                매인 웹사이트
            </td>
            <td>
                <a href="https://github.com/schoolbell-e/sbe-web-v4/issues" target="_blank">https://github.com/schoolbell-e/sbe-web-v4/issues</a>
            </td>
            <td>x</td>
        </tr>
        <tr>
            <td>
                어플리케이션
            </td>
            <td>
                <a href="https://github.com/schoolbell-e/sbe-app-v4/issues" target="_blank">https://github.com/schoolbell-e/sbe-app-v4/issues</a>
            </td>
            <td>x</td>
        </tr>
        <tr>
            <td>
                서포트 웹사이트
            </td>
            <td>
                <a href="https://github.com/schoolbell-e/sbe-support/issues" target="_blank">https://github.com/schoolbell-e/sbe-support/issues</a>
            </td>
            <td>x</td>
        </tr>
        <tr>
            <td>
                스태프 웹사이트
            </td>
            <td>
                <a href="https://github.com/schoolbell-e/sbe-staff/issues" target="_blank">https://github.com/schoolbell-e/sbe-staff/issues</a>
            </td>
            <td>x</td>
        </tr>

    </tbody>
</table>
